export default __webpack_public_path__ + "static/media/01.afc87c9a.jpg";